import React from "react";

export interface Options {
    value: string;
    label: React.ReactNode;
}

export interface CheckboxProps {
    id?: string;
    disabled?: boolean;
    className?: string;
    required?: boolean;
    groupClassName?: string;
    labelClassName?: string;
    fields?: {
        value?: string[];
        length: number;
        push: (value: string) => void;
        remove: (index: number) => void;
    };
    name: string;
    options: Array<Options>;
    maxCheckedValue?: number;
    key?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
    groupClassName,
    labelClassName,
    options,
    fields,
    maxCheckedValue,
    ...props
}) => {
    const toggle = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
        if (!fields) return;
        if (maxCheckedValue && fields.length >= maxCheckedValue) {
            if (!event.target.checked) {
                const idx = fields.value?.indexOf(value) ?? -1;
                if (idx >= 0) fields.remove(idx);
            }
        } else {
            if (event.target.checked) {
                fields.push(value);
            } else {
                const idx = fields.value?.indexOf(value) ?? -1;
                if (idx >= 0) fields.remove(idx);
            }
        }
    };

    return (
        <React.Fragment>
            {options.map((option) => {
                const id = `${props.name}_${option.value}`;
                const checked = fields?.value !== undefined && fields.value.includes(option.value);
                return (
                    <div className={groupClassName} key={option.value}>
                        <input
                            type="checkbox"
                            onChange={(event) => toggle(event, option.value)}
                            checked={checked}
                            value={option.value}
                            {...props}
                            id={id}
                        />
                        <label className={labelClassName} htmlFor={id}>
                            {option.label}
                        </label>
                    </div>
                );
            })}
        </React.Fragment>
    );
};

Checkbox.defaultProps = {
    className: "field__checkbox-input",
    groupClassName: "field__checkbox-group",
    labelClassName: "field__checkbox-label",
};

export default Checkbox;
